<template>
  <div class="filter">
    <div class="section section--filter">
      <div class="wrapper">
        <div class="container">
          <form action="#"
                class="form form--filter form--filter-vehicles large-width"
                @submit="formSubmitHandler">
            <div v-if="isContentReady">

              <div class="filters">
                <div class="field-group field-group--select">
                  <label for="selectedBrand"
                         class="label label--select">{{ lexicon.brand }}</label>

                  <template v-if="isMobileAndTouch">
                    <select class="select"
                            :class="[{'select--dark': selectedBrand !== '*'}]"
                            v-model="selectedBrand"
                            name="selectedBrand"
                            id="selectedBrand">
                      <option v-for="item in brands" :value="item.id">{{ item.name }}</option>
                    </select>
                  </template>

                  <template v-else>
                    <multiselect v-if="brands && brands.length > 0"
                                 v-model="selectedBrandObject"
                                 :options="brands"
                                 id="selectedBrand"
                                 class="multiselect--small multiselect--regular"
                                 :class="[{'select--dark': selectedBrand !== '*'}]"
                                 label="name"
                                 :placeholder="lexicon.all"
                                 track-by="id">
                      <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
                    </multiselect>
                  </template>
                </div>

                <div class="field-group field-group--select">
                  <label for="selectedModel"
                         class="label label--select">{{ lexicon.model }}</label>
                  <template v-if="isMobileAndTouch">
                    <select class="select"
                            :class="[{'select--dark': selectedModel !== '*'}]"
                            v-model="selectedModel"
                            name="selectedModel"
                            id="selectedModel">
                      <option v-for="item in availableModels" :value="item.id">{{ item.model }}</option>
                    </select>
                  </template>
                  <template v-else>
                    <multiselect v-if="availableModels && availableModels.length > 0"
                                 v-model="selectedModelObject"
                                 :options="availableModels"
                                 id="selectedModel"
                                 class="multiselect--small multiselect--regular"
                                 :class="[{'select--dark': selectedModel !== '*'}]"
                                 label="model"
                                 :placeholder="lexicon.all"
                                 track-by="model">
                      <template slot="singleLabel" slot-scope="{ option }">{{ option.model }}</template>
                    </multiselect>
                  </template>
                </div>

                <div class="field-group field-group--select">
                  <label for="selectedCondition"
                         class="label label--select">{{ lexicon.condition ? lexicon.condition : 'Fahrzeugzustand' }}</label>

                  <template v-if="isMobileAndTouch">
                    <select class="select"
                            :class="[{'select--dark': selectedCondition !== '*'}]"
                            v-model="selectedCondition"
                            name="selectedCondition"
                            id="selectedCondition">
                      <option v-for="item in condition" :value="item.id">{{ item.name }}</option>
                    </select>
                  </template>

                  <template v-else>
                    <multiselect v-if="condition && condition.length > 0"
                                 v-model="selectedConditionObject"
                                 :options="condition"
                                 id="selectedCondition"
                                 class="multiselect--small multiselect--regular"
                                 :class="[{'select--dark': selectedCondition !== '*'}]"
                                 label="name"
                                 :placeholder="lexicon.all"
                                 track-by="id">
                      <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
                    </multiselect>
                  </template>
                </div>

                <div class="field-group field-group--select">
                  <label for="selectedYear"
                         class="label label--select">{{ lexicon.year_from }}</label>
                  <template v-if="isMobileAndTouch">
                    <select class="select"
                            :class="[{'select--dark': selectedYear !== '*'}]"
                            v-model="selectedYear"
                            name="selectedYear"
                            id="selectedYear">
                      <option v-for="item in years" :value="item.value">{{ item.label }}</option>
                    </select>
                  </template>

                  <template v-else>
                    <multiselect v-if="years && years.length > 0"
                                 v-model="selectedYearObject"
                                 :options="years"
                                 id="selectedYear"
                                 class="multiselect--small multiselect--regular"
                                 :class="[{'select--dark': selectedYear !== '*'}]"
                                 label="label"
                                 :placeholder="lexicon.all"
                                 track-by="value">
                      <template slot="singleLabel" slot-scope="{ option }">{{ option.label }}</template>
                    </multiselect>
                  </template>
                </div>
                <div class="field-group field-group--select">
                  <label for="selectedType"
                         class="label label--select">{{ lexicon.vehicle_type }}</label>

                  <template v-if="isMobileAndTouch">
                    <select class="select"
                            :class="[{'select--dark': selectedType !== '*'}]"
                            v-model="selectedType"
                            name="selectedType"
                            id="selectedType">
                      <option v-for="item in types" :value="item.id">{{ item.name }}</option>
                    </select>
                  </template>
                  <template v-else>
                    <multiselect v-if="types && types.length > 0"
                                 v-model="selectedTypeObject"
                                 :options="types"
                                 id="selectedType"
                                 class="multiselect--small multiselect--regular"
                                 :class="[{'select--dark': selectedType !== '*'}]"
                                 label="name"
                                 :placeholder="lexicon.all"
                                 track-by="id">
                      <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
                    </multiselect>
                  </template>
                </div>

              </div>

              <div class="field-group field-group--range">
                <label for="priceInput" class="label label--select">{{ lexicon.price }}</label>

                <vue-slider
                    :min="minPrice"
                    :max="maxPrice"
                    :height="11"
                    step="100"
                    v-model="selectedRangePrice"
                    :tooltip-formatter="priceFormatter"
                />

                <!--                <input type="range"
                                       v-model="selectedPrice"
                                       id="priceInput"
                                       name="priceInput"
                                       :min="minPrice"
                                       :style="{background: `linear-gradient(to right, rgba(41,153,88,1), rgba(0,153,153,1) ${selectedPriceToPercent/2}%, rgba(13,146,205,1) ${selectedPriceToPercent}%, #F5F5F5 ${selectedPriceToPercent}%, #F5F5F5 100%)`}"
                                       step="100"
                                       :max="maxPrice">-->
                <span class="input-range__min">{{ convertToCurrency(minPrice) }}</span>
                <span class="input-range__max">{{ convertToCurrency(maxPrice) }}</span>
              </div>

              <button class="action action--underline action--reset"
                      @click="resetFilters">
                <span class="action__text">{{ lexicon.filter_reset }}</span>
              </button>
            </div>
            <template v-else>
              <content-loader
                  :height="219"
                  :width="1050"
                  :speed="2"
                  primaryColor="#f3f3f3"
                  secondaryColor="#ecebeb"
              >
              </content-loader>
            </template>
          </form>
        </div>
      </div>
    </div>

    <div class="section section--results section--background-tertiary">
      <div class="wrapper">
        <div class="container">

          <template v-if="isContentReady">

            <template v-if="selectionPaginated && selectionPaginated.length > 0">
              <div class="section--results__header">
                <p class="font-weight-bold">{{ (isOnlyFirstPageLoaded ? totalOnFirstPageLoaded : selection.length) + ' ' + lexicon.vehicles }}</p>

                <div class="field-group field-group--select field-group field-group--select-sort">
                  <label for="sort" hidden>{{ lexicon.sorting }}</label>
                  <template v-if="isMobileAndTouch">
                    <select class="select select--sort"
                            id="sort"
                            v-model="sortByType"
                            name="sort">
                      <option value="*" disabled>{{ lexicon.sorting }}</option>
                      <option :value="option.value" :disabled="option.isDisabled" v-for="option in sortOptions">{{ option.label }}</option>
                    </select>
                  </template>

                  <template v-else>
                    <multiselect v-if="sortOptions && sortOptions.length > 0"
                                 v-model="sortByTypeObject"
                                 :options="sortOptions"
                                 id="sort"
                                 class="multiselect--small multiselect--sort"
                                 label="label"
                                 :placeholder="lexicon.sorting"
                                 track-by="value">
                      <template slot="singleLabel" slot-scope="{ option }">{{ option.label }}</template>
                    </multiselect>
                  </template>
                </div>

              </div>

              <div class="row row--grid">
                <template v-for="item in selectionPaginated">
                  <v-deal :item="item" :lexicon="lexicon"></v-deal>
                </template>
              </div>

            </template>

            <div class="row row--grid" v-if="selectionPaginated && selectionPaginated.length === 0">
              <div class="col col-sm-12 col-md-12 offset-lg-2 col-lg-8">
                <div v-html="lexicon.no_result" class="body"></div>
              </div>
            </div>

            <div v-if="selection.length > selectionPaginated.length">
              <div class="action__container action__container--center">
                <button class="action action--bordered" @click="showMore">
                  <span class="action__text">{{ lexicon.show_more }}</span>
                </button>
              </div>
            </div>
          </template>

          <template v-else>
            <div class="row row--grid">
              <content-loader
                  class="col col-sm-12 col-md-12 col-lg-4 teaser--deals"
                  v-for="i in 9"
                  :height="560"
                  :width="500"
                  :speed="2"
                  primaryColor="#b8b7b7"
                  secondaryColor="#c2c2c2"
                  :key="i"
              ></content-loader>
            </div>
          </template>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getVehiclesListContent,
  getLexicon,
  getVehicleContent,
} from '../rest-service/rest-service';
import VDeal from '../VDeal/VDeal.vue';
import VMixins from '../VMixins/VMixins.vue';
import VueSlider from 'vue-slider-component';
import staticVars from '../static-vars/static-vars';

const templateUrl = staticVars.templateUrl;
export default {
  name: 'VDeals.vue',
  mixins: [VMixins],
  data() {
    return {
      deals: [],
      brands: [],
      models: [],
      years: [],
      types: [],
      condition: [],

      selectedYear: '*',
      selectedBrand: '*',
      selectedModel: '*',
      selectedType: '*',
      selectedCondition: '*',

      selectedPrice: 0,
      selectedRangePrice: [0, 100],
      minPrice: 0,
      maxPrice: 0,

      sortByType: '*',
      sortByTypeObject: null,

      selectedYearObject: null,
      selectedModelObject: null,
      selectedBrandObject: null,
      selectedTypeObject: null,
      selectedConditionObject: null,

      page: 1,
      pageAutoscout: 1,

      totalOnFirstPageLoaded: 0,
      isOnlyFirstPageLoaded: false,

      lexicon: {},
      isContentReady: false,

      posts_per_page: 9,

      priceFormatter: v => {
        let value = new Intl.NumberFormat('de-CH',
            {style: 'currency', currency: 'CHF'},
        ).format(v).replace('.00', '.—');

        return value.replace(/&nbsp;/g, '').replace('CHF', '');
      },
    };
  },
  components: {
    VDeal,
    VueSlider,
  },

  computed: {
    sortOptions() {
      return [
        {
          value: 'price_desc',
          label: this.lexicon.price + ': ' + this.lexicon.high,
        },
        {
          value: 'km_asc',
          label: this.lexicon.mileage + ': ' + this.lexicon.low,
        },
        {
          value: 'km_desc',
          label: this.lexicon.mileage + ': ' + this.lexicon.high,
        },
        {
          value: 'year_asc',
          label: this.lexicon.year + ': ' + this.lexicon.old,
        },
        {
          value: 'year_desc',
          label: this.lexicon.year + ': ' + this.lexicon.new,
        },
        {
          value: 'makemodel_asc',
          label: this.lexicon.brand + ', ' + this.lexicon.model + ': A–Z',
        },
        {
          value: 'makemodel_desc',
          label: this.lexicon.brand + ', ' + this.lexicon.model + ': Z–A',
        },
        {
          value: 'hp_desc',
          label: this.lexicon.power + ': ' + this.lexicon.high,
        },
      ];
    },

    selection() {
      return this.sortBy(this.deals.filter(deal => {
        return deal.id !== '*'
            && this.getModelsByBrand(deal, this.selectedBrand)
            && this.dealMatchesModelSelection(deal, this.selectedModel)
            && this.getModelsByType(deal, this.selectedType)
            && this.getModelsByYear(deal, this.selectedYear)
            && this.getModelsByPrice(deal, this.selectedRangePrice)
            && this.getModelsByCondition(deal, this.selectedCondition);
      }));

    },

    selectionPaginated() {
      return this.selection.slice(0, this.posts_per_page * this.page);
    },

    availableModels() {
      let temp = [];
      if (this.selectedBrand === '*') {
        temp = this.models;
      } else {
        temp = this.models.filter(item => item.MakeId === this.selectedBrand);
        if (this.selectedModel !== '*' && !temp.find(item => item.id === this.selectedModel)) {
          this.selectedModel = '*';
          this.selectedModelObject = {'model': this.lexicon.all, id: '*'};
        }
      }

      return [{'model': this.lexicon.all, id: '*'}, ...this.sortAlphabetically(temp, 'model')];
    },

    selectedPriceToPercent() {
      return `${(this.selectedPrice - this.minPrice) * 100 / (this.maxPrice - this.minPrice)}`;
    },
  },

  created() {

    const getDummyContent = () => {
      return new Promise(resolve => {
        fetch(`${templateUrl}/assets/data/dummy.json`).then((response) => {
          return response.json();
        }).then((json) => {
          resolve((JSON.parse(json)).Vehicles);
        }).catch((ex) => {
          console.log('parsing failed', ex);
        });
      });
    };

    const getVehiclesListPage = (member, page, lang) => {
      return new Promise((resolve, reject) => {

        getVehiclesListContent({
          member: member,
          page: page,
          lng: this.lang,
        }, (result) => {
          this.totalOnFirstPageLoaded = result.data.totalElements;
          resolve(result.data.content);
        });
      });
    };

    const getLexiconContent = () => {
      return new Promise(resolve => {
        getLexicon(this.lang, (response) => {
          resolve(response.data);
        });
      });
    };

    const getVehiclesContentPageAfterFirst = (member) => {
      this.pageAutoscout = 1;

      return new Promise(resolve => {
        getVehiclesListContent({
          member: member,
          page: this.pageAutoscout,
          lng: this.lang,
        }, (result) => {
          const response = typeof result.data === 'string' ? JSON.parse(result.data) : result.data;
          let temp = response.content;
          this.pageAutoscout++;
          let promises = [];

          for (let pageNum = this.pageAutoscout; pageNum < response.totalPages; pageNum++) {
            promises = [...promises, ...[getVehiclesListPage(member, pageNum, this.lang)]];
          }

          Promise.all(promises).then(result => {

            for (let batch of result) {
              temp = [...temp, ...batch];
            }

            resolve(temp);
          });
        });
      });
    };

    Promise.all([
      //getDummyContent(),
      getVehiclesListPage(1011620, 0, this.lng),
      getLexiconContent(),

    ]).then(result => {

      this.lexicon = result[1];

      const tempDeals = result[0];
      // console.log(tempDeals)
      this.setContent(tempDeals);
      this.isOnlyFirstPageLoaded = true;

      this.isContentReady = true;

      getVehiclesContentPageAfterFirst(1011620).then(response => {
        if (response) this.setContent(response);
        this.isOnlyFirstPageLoaded = false;

        // console.log(this.deals);
      });
    });
  },
  methods: {
    translate(key, value) {
      return this.lexicon.interface[`${key}.${value}`] || value;
    },

    setContent(deals) {

      this.deals = [
        ...this.deals, ...deals.filter(item => item.price !== null),
        //.filter(item => item.ModelText !== "")
        // .map(item => {
        //   item.model.name = item.model.name === "" ? item.model.name : item.ModelText;
        //   return item
        // })
      ];

      const tempTypes = this.deals.map(item => {
        return {
          id: item.bodyType,
          name: this.translate('bodyType', item.bodyType),
        };
      });

      this.types = [
        {id: '*', name: this.lexicon.all}, ...this.sortAlphabetically(Array.from(new Set(tempTypes.map(a => a.id))).map(id => {
          return tempTypes.find(a => a.id === id);
        }), 'name')];

      const tempBrands = this.deals.map(item => {
        return {
          id: item.make.key,
          name: item.make.name,
        };
      });

      this.brands = [
        {id: '*', name: this.lexicon.all}, ...this.sortAlphabetically(Array.from(new Set(tempBrands.map(a => a.id))).map(id => {
          return tempBrands.find(a => a.id === id);
        }), 'name')];

      const tempConditions = this.deals.map(item => {
        return {
          id: item.conditionType,
          name: this.translate('conditionType', item.conditionType),
        };
      });

      this.condition = [
        {id: '*', name: this.lexicon.all}, ...this.sortAlphabetically(Array.from(new Set(tempConditions.map(a => a.id))).map(id => {
          return tempConditions.find(a => a.id === id);
        }), 'name')];

      this.years = [...new Set(this.deals.map(item => item.firstRegistrationYear))].sort();
      this.years = [{label: 'Alle', value: '*'}, ...this.years.map(item => item = {label: item, value: item})];

      const tempModels = this.deals.map(item => {
        if (!item.model) {
          return null;
        }
        return {
          id: item.model.key,
          MakeId: item.make.key,
          model: `${item.model.name}`,
        };
      }).filter(item => item !== null);

      this.models = this.sortAlphabetically(Array.from(new Set(tempModels.map(a => a.id))).map(id => {
        return tempModels.find(a => a.id === id);
      }), 'model');

      try {
        this.maxPrice = Math.ceil(this.deals.reduce((max, p) => p.price > max ? p.price : max, this.deals[0].price));
      } catch (e) {
        this.maxPrice = 0;
      }

      try {
        this.minPrice = this.deals.reduce((min, p) => p.price < min ? p.price : min, this.deals[0].price);
      } catch (e) {
        this.minPrice = 0;
      }

      this.selectedPrice = this.maxPrice;
      this.selectedRangePrice = [this.minPrice, this.maxPrice];

      this.selectedYearObject = {label: this.lexicon.all, value: '*'};
    },

    sortBy(array) {
      if (this.sortByType === 'price_asc') {
        return array.sort((a, b) => a.price > b.price ? 1 : -1);
      } else if (this.sortByType === 'price_desc') {
        return array.sort((a, b) => b.price > a.price ? 1 : -1);
      } else if (this.sortByType === 'km_asc') {
        return array.sort((a, b) => a.mileage > b.mileage ? 1 : -1);
      } else if (this.sortByType === 'km_desc') {
        return array.sort((a, b) => b.mileage > a.mileage ? 1 : -1);
      } else if (this.sortByType === 'year_asc') {
        return array.sort((a, b) => a.firstRegistrationYear > b.firstRegistrationYear ? 1 : -1);
      } else if (this.sortByType === 'year_desc') {
        return array.sort((a, b) => b.firstRegistrationYear > a.firstRegistrationYear ? 1 : -1);
      } else if (this.sortByType === 'makemodel_asc') {
        return array.sort((a, b) => a.versionFullName.localeCompare(b.versionFullName));
      } else if (this.sortByType === 'makemodel_desc') {
        return array.sort((a, b) => b.versionFullName.localeCompare(a.versionFullName));
      } else if (this.sortByType === 'hp_desc') {
        return array.sort((a, b) => b.horsePower > a.horsePower ? 1 : -1);
      } else {
        return array;
      }

    },

    getModelsByBrand(item, brand) {
      if (brand !== '*') {
        return item.make.key === brand;
      }

      return true;
    },

    getModelsByPrice(item, rangePrice) {
      if (rangePrice.length === 2 && this.selectedModel === '*') {
        return item.price <= rangePrice[1] && item.price >= rangePrice[0];
      }

      return true;
    },

    getModelsByCondition(item, conditionId) {
      if (conditionId !== '*') {
        return item.conditionType === conditionId;
      }

      return true;
    },

    dealMatchesModelSelection(deal, selection) {
      if (selection === '*') {
        return true;
      }

      if (!deal.hasOwnProperty('model') || !deal.model) {
        return false;
      }

      if (!deal.model.hasOwnProperty('key')) {
        return false;
      }

      // console.log('isMatch: ' + (deal.model.key === selection));
      if (deal.model.key == selection) {
        // console.log(`matches for choice ${selection}`);
        // console.log('item:' + deal.model.key);

        return true;
      }

      return deal.model.key == selection;
    },

    getModelsByYear(item, year) {
      if (year !== '*') {
        return item.firstRegistrationYear >= year;
      }

      return true;
    },

    getModelsByType(item, type) {
      if (type !== '*') {
        return item.bodyType === type;
      }

      return true;
    },

    resetFilters(evt) {
      evt.preventDefault();

      this.page = 1;

      this.selectedBrandObject = this.brands[0];
      this.selectedModelObject = this.availableModels[0];
      this.selectedTypeObject = this.types[0];
      this.selectedConditionObject = this.condition[0];
      this.selectedYear = this.years[0];

      this.selectedBrand = '*';
      this.selectedModel = '*';
      this.selectedType = '*';
      this.selectedYear = '*';
      this.selectedCondition = '*';
      this.sortByType = '*';

      this.selectedPrice = this.maxPrice;
      this.selectedRangePrice = [this.minPrice, this.maxPrice];
    },
  },

  watch: {
    selection: {
      immediate: false,
      deep: false,
      handler(newValue) {
        this.page = 1;
      },
    },

    sortByTypeObject: {
      immediate: false,
      deep: false,
      handler(newValue) {
        if (newValue === null) {
          this.sortByType = '*';
        } else {
          this.sortByType = newValue.value;
        }

      },
    },

    selectedBrandObject: {
      immediate: false,
      deep: true,
      handler(newValue) {
        this.selectedBrand = newValue ? newValue.id : '*';
      },
    },

    selectedYearObject: {
      immediate: false,
      deep: true,
      handler(newValue) {
        this.selectedYear = newValue ? newValue.value : '*';
      },
    },

    selectedModelObject: {
      immediate: false,
      deep: true,
      handler(newValue) {
        this.selectedModel = newValue ? newValue.id : '*';
      },
    },
    selectedTypeObject: {
      immediate: false,
      deep: true,
      handler(newValue) {
        this.selectedType = newValue ? newValue.id : '*';
      },
    },
    selectedConditionObject: {
      immediate: false,
      deep: true,
      handler(newValue) {
        this.selectedCondition = newValue ? newValue.id : '*';
      },
    },
  },
};
</script>
